import Reflux from 'reflux';

import actions from '../actions';
import configurationStore from './configuration-store';

import baseStateStore from './base-state-store';

import {matchMedia} from '../../breakpoints';

export default Reflux.createStore(
	Object.assign({}, baseStateStore, {
		init() {
			this.listenToMany(actions);
			this.listenTo(configurationStore, this.onConfigurationChange);
			this.state = {
				itemListPage: -1,
				lastSelectedFacetId: undefined,
				lastClickedFacetId: undefined,
				userSelection: {},
				configuration: {
					preselection: {},
					defaultUserSelection: {},
					automaticUserSelection: {}
				},
				propWidth: 300
			};
		},

		onConfigurationChange(configuration) {
			this.state.configuration = {
				preselection: configuration.preselection,
				defaultUserSelection: configuration.defaultUserSelection,
				automaticUserSelection: configuration.automaticUserSelection
			};
		},

		onLoadItemSheet() {
			this.state.itemListPage = 0;
			this.output();

			actions.loadItem();
		},

		onNextItemListPage() {
			this.state.itemListPage++;
			this.output();

			actions.loadItems();
		},

		onResetItemListPage() {
			this.state.itemListPage = -1;
			this.output();

			actions.loadItems();
		},

		onLoadItemsCompleted() {
			actions.loadItemsDone();
		},

		onInitializeWizards(initialState) {
			const initialSelection = Object.assign({}, this.state.configuration.preselection,
				this.state.configuration.defaultUserSelection, initialState && initialState.userSelection || {});
			let isLoadedWithId = window.location.hash === '#downloads';
			isLoadedWithId = isLoadedWithId && window.location.search.match(/([^&=]id)=([^&]+)/g);
			actions.selectProperties(initialSelection, isLoadedWithId);
			actions.updateTabs(initialSelection);
		},

		onSelectProperties(properties, isLoadedWithId) {
			this.state.userSelection = properties;
			Object.keys(properties).forEach((facetId) => {
				this._applyAutomaticUserSelection(properties[facetId]);
			});

			const isItemListActivated = this.state.itemListPage > -1;
			this.state.itemListPage = isItemListActivated ? 0 : -1;
			this.output();
			actions.loadFacets();
			actions.loadItemCount({autoSheet: isLoadedWithId});
			actions.loadAccessoryIdsForItems();

			if (isItemListActivated) {
				actions.loadItems();
			}
		},

		onSelectProperty(facet, property) {
			if (property.countUnselected === 0 && !facet.isPreselecting) {
				return;
			}

			// get current state
			const currentPropertyId = this.state.userSelection[facet.id];
			const newPropertyId = currentPropertyId !== property.id ? property.id : null;

			if (newPropertyId === null && !property.isDeselectable) {
				return;
			}

			// reset selection?
			if (facet.isPreselecting) {
				this._applyDefaultUserSelection();
			}

			// reset other facets?
			this._applyResetting(facet.resettingOtherFacetIds);

			// make selection
			this._applyUserSelection(facet.id, newPropertyId);

			// automatic user selection
			this._applyAutomaticUserSelection(property.id);

			// last facet for scrolling etc.
			this.state.lastClickedFacetId = facet.id;
			if (this.state.itemListPage > -1) {
				this.state.itemListPage = 0;
			}
			this.output();

			actions.loadFacets();
			actions.loadItemCount({autoSheet: true});
			actions.loadAccessoryIdsForItems();
			if (this.state.itemListPage > -1) {
				actions.loadItems();
			}

			actions.updateTabs(this.state.userSelection);
		},

		onWindowResize(winWidth, refWidth) {
			let cols = 5;
			if (matchMedia('<tablet')) {
				cols = 1;
			} else if (matchMedia('<desktop')) {
				cols = 3;
			}

			this.state.propWidth = Math.floor(refWidth / cols);
			this.output();
		}
	})
);
